import Loading from "@/components/Loading/Loading"
import NoMessage from "@/components/noMessage/NoMessage"
import FreeMaterialCourse from "@/features/pages/FreeMaterials/FreeMaterialCourse"
import {
  useFreeMaterialData,
  useFreeMaterialSettings,
  useStudentFreeMaterialEnrollments,
} from "@/queries/queries/freeMaterialsQueries"
import { Row } from "react-bootstrap"
import { useTranslation } from "react-i18next"

export default function FreeMaterials() {
  const { t } = useTranslation()

  const freeMaterialsQuery = useFreeMaterialData()
  const studentFreeMaterialEnrollmentQuery = useStudentFreeMaterialEnrollments()
  const freeMaterialSettingsQuery = useFreeMaterialSettings()

  if (
    freeMaterialsQuery.isLoading ||
    studentFreeMaterialEnrollmentQuery.isLoading ||
    freeMaterialSettingsQuery.isLoading
  )
    return <Loading />

  if (
    !freeMaterialsQuery.data?.data ||
    !freeMaterialsQuery.data.data?.length ||
    !freeMaterialSettingsQuery.data?.length
  )
    return <NoMessage name={t("noMessages.freeMaterials")} />

  return (
    <Row className="gy-2">
      {freeMaterialsQuery.data.data.map((item) => (
        <FreeMaterialCourse key={item.id} course={item} />
      ))}
    </Row>
  )
}
